import { Stack, TextField } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import Iconify from 'src/components/iconify';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '25px',
  boxShadow: 24,
  p: 4,
};

export default function TreeModal(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // console.log('props', props);
  const folderNameRef = React.useRef('');
  const handleFolderChange = (e) => {
    e.preventDefault();
    console.log('folderNameRef?.current?.value:', folderNameRef?.current?.value);
    props.setFolderName(folderNameRef?.current?.value);
  };
  return (
    <div>
      <Stack direction="row" onClick={handleOpen}>
        <Iconify icon={props.icon} sx={{ mr: 2 }} />
        <Typography variant="subtitle2">{props.title}</Typography>
      </Stack>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Stack direction="column" alignItems="center" justifyContent="center" spacing={4} mb={4}>
              <Typography variant="h6" color="initial">
                <span style={{ color: '#ad1f22' }}>{props.description}</span>
              </Typography>
              <TextField
                label="Folder Name"
                variant="outlined"
                fullWidth
                size="small"
                onChange={handleFolderChange}
                defaultValue={props?.oldName}
                inputRef={folderNameRef}
              />
            </Stack>
            <Stack direction="row" justifyContent="center" alignItems="flex-end" spacing={2}>
              <Button onClick={props.Hit} disabled={folderNameRef?.current?.value == ''} variant="contained">
                Save
              </Button>
              <Button onClick={handleClose} variant="contained">
                Close
              </Button>
            </Stack>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
